export const userGroupConstants = {
  ACL_USER_GROUP_LIST_REQUEST: 'ACL_USER_GROUP_LIST_REQUEST',
  ACL_USER_GROUP_LIST_SUCCESS: 'ACL_USER_GROUP_LIST_SUCCESS',
  ACL_USER_GROUP_LIST_FAILURE: 'ACL_USER_GROUP_LIST_FAILURE',
  ACL_USER_GROUP_LIST_CHANGED: 'ACL_USER_GROUP_LIST_CHANGED',
  ACL_USER_GROUP_LIST_PAGINATION: 'ACL_USER_GROUP_LIST_PAGINATION',

  ACL_USER_GROUP_LOAD_REQUEST: 'ACL_USER_GROUP_LOAD_REQUEST',
  ACL_USER_GROUP_LOAD_SUCCESS: 'ACL_USER_GROUP_LOAD_SUCCESS',
  ACL_USER_GROUP_LOAD_FAILURE: 'ACL_USER_GROUP_LOAD_FAILURE',

  ACL_USER_GROUP_SAVE_REQUEST: 'ACL_USER_GROUP_SAVE_REQUEST',
  ACL_USER_GROUP_SAVE_SUCCESS: 'ACL_USER_GROUP_SAVE_SUCCESS',
  ACL_USER_GROUP_SAVE_FAILURE: 'ACL_USER_GROUP_SAVE_FAILURE',
};
